import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonRadioGroupModule, FormValidationModule } from '@tablesready/common-ui';
import { SizeComponent } from './size.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonRadioGroupModule,
    FormValidationModule,
  ],
  declarations: [SizeComponent],
  exports: [SizeComponent],
})
export class SizeModule {
}
